<template>
  <div class="filter-result">
    <!-- <div class="electronic-lecture__head filter-result__head display-flex-center justify-content-between">
      <h2 class="primary-color-txt font-size-24 font-sanpro-semibold">Học liệu theo mục lục</h2>
    </div> -->
    <!-- <div class="row">
      <div class="item col-sm-6 col-md-4 col-lg-3" v-for="(item, index) of dataSource" :key="index">
        <div class="item__wrap display-flex">
          <div class="item__img">
            <router-link :to="{name: 'LibraryAllOfBook', params: {book: item.bookId, subjectId: item.subjectId, classId: item.classId, type: typeLoading}}">
              <img :src="item.imageUrl ?  `${urlImg}/${item.imageUrl}` : img404" :alt="item.name">
            </router-link>
          </div>
          <div class="item__content">
            <h3 class="item__title font-size-17 font-sanpro-semibold">
              <router-link class="primary-color-txt" :to="{name: 'LibraryAllOfBook', params: {book: item.bookId, subjectId: item.subjectId, classId: item.classId, type: typeLoading}}">
                {{ item.name }}</a>
              </router-link>
            </h3>
            <p class="margin-0 text-right item__count font-size-12 secondary-color-txt">
              <span>{{ item.total ? item.total : 0 }} học liệu</span>
            </p>
          </div>
        </div>
      </div>
    </div> -->
    <div class="electronic-lecture__body filter-result__body">
      <!-- hahah data 123 - {{ dataSource }} -->
      <div class="row" v-if="dataSource && dataSource.length > 0">
        <div
          class="item col-sm-6 col-md-4 col-lg-3"
          v-for="(item, index) of dataSource"
          :key="index"
        >
          <!-- :class="{'item--lock': !item.isActived}" -->
          <div class="item__wrap">
            <div class="item__head position-rel">
              <div class="item__img aspect-ratio aspect-ratio--16-9 text-center border-rd-4 bg-transparent" @click="handleDirectToLibByBook(item)">
                <a href="javascript:;">
                  <img :src="item.imageUrl ? `${urlImg}/${item.imageUrl}` : img404" :alt="item.name">
                </a>
              </div>
              <p class="margin-0 text-center item__count font-size-14 color-light font-sanpro-light">
                <span>{{ item.total ? item.total : item.countActive }} học liệu </span>
              </p>
              <!-- <div v-if="!item.isActived" class="item__head__hover">
                <span class="icon-nhom-hoc-lieu font-size-24"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>
              </div> -->
            </div>
            <div class="item__content">
              <h3 class="item__title font-size-16 font-sanpro-semibold" @click="handleDirectToLibByBook(item)">
                {{ item.name }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import { STORE_KEY } from './../../_store/constants'
  import { STORE_KEY_EBOOK } from '../../../ebooks/_store/constants'

  import { APP_CONFIG } from '@/utils/constants'
  const img404 = require(`@/assets/images/img_404.jpg`)
  import { getAuth } from '@/utils/jwt'
  import { EMAIL_PUBLIC } from '@/store/auth/constants'
  import { ID_MODAL_ACTIVE_BOOK } from './../../_store/constants'

  export default {
    name: 'ResultBookFilter',
    props: {
      dataSource: Array,
      typeLoading: Number
    },
    data () {
      return {
        urlImg: APP_CONFIG.urlQuestionImg,
        img404,
        authInfo: {}
      }
    },
    computed: {
      ...mapState(STORE_KEY, ['resultBookPageLinkFilter', 'resultBookLessonFilter']),
      ...mapState('auth', ['loginPopupData']),
      ...mapGetters({
        ebooks: STORE_KEY_EBOOK + '/ebooks'
      })
    },
    watch: {
      loginPopupData(newVal) {
        if(newVal && Object.keys(newVal).length) {
          this.authInfo = newVal;
          this.$bvModal.show(ID_MODAL_ACTIVE_BOOK);
        }
      }
    },
    created() {
      this.authInfo = getAuth();
    },
    destroyed () {
      // this.dataSource = []
      this.actionSetValueListAtvLearn([])
    },
    methods: {
      ...mapActions('auth', ['setToggleLoginForm']),
      ...mapActions(STORE_KEY, ['actionSetValueListAtvLearn']),

      handleDirectToLibByBook (val) {
        // if(this.authInfo && this.authInfo.email === EMAIL_PUBLIC && !val.isActived) {
        //     this.setToggleLoginForm(true);
        // } else if(this.authInfo && this.authInfo.email !== EMAIL_PUBLIC && !val.isActived) {
        //     this.$bvModal.show(ID_MODAL_ACTIVE_BOOK);
        // } else {
          // console.log('ebooks', this.ebooks);
          // console.log('vlalvlavlalva', val);
          this.$router.push({name: 'LibraryAllOfBook', params: {book: val.bookId, subjectId: val.subjectId, classId: val.classId, type: this.typeLoading}});
        // }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .filter-result {
    &__body {

      .item {
        margin-bottom: 25px;

        &__img {
          margin-bottom: 0;
        }

        &__head {
          border-radius: 4px;
          overflow: hidden;

          &__hover {
            position: absolute;
            top: 0;
            bottom: 7px;
            left: 0;
            right: 0;
            background: rgba(0,0,0,.3);
            display: flex;
            align-items: center;
            justify-content: center;
            @extend .effect-transition-fast;
            // @extend .effect-hide-hover;
            pointer-events: none;
            @extend .border-rd-4;
          }
        }

        &__count {
          position: absolute;
          // bottom: 7px;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0,0,0,.3);
          border-radius: 0 0 4px 4px;
          z-index: 1;
        }

        &__content {
          padding: 8px 0;
        }

        &:hover {
          .item {
            &__title {
              @extend .primary-color;
            }
            // &__head__hover {
            //   @extend .effect-show-hover;
            // }

            // &__count {
            //   @extend .bg-transparent;
            // }
          }
        }

        &--lock {
          .item {
            &__count {
              @extend .bg-transparent;
            }
          }
        }
      }
    }
  }
  // .filter-result {
  //   margin-top: 20px;

  //   .item {
  //     margin-bottom: 15px;

  //     &__wrap {
  //       @extend .color_bg_gray_light;
  //       @extend .border-rd-4;
  //     }

  //     &__img {
  //       max-width: 80px;

  //       img {
  //         @extend .border-rd-4;
  //       }
  //     }

  //     &__content {
  //       padding: 8px 10px;
  //       width: calc(100% - 80px);
  //       @extend .display-flex;
  //       flex-direction: column;
  //       @extend .justify-content-between;
  //     }

  //     &:hover {
  //       .item__img {
  //         opacity: .7;
  //       }
  //     }
  //   }
  // }
  .electronic-lecture {
    &__head {
      padding-bottom: 7px;
      border-bottom: 1px solid #d0d5d8;
      margin: 32px 0 24px 0;
    }
    &__body {
      .text-width {
        overflow: hidden;
      }
      .item-lecture {
        &:hover {
          opacity: 0.8;
        }
      }
      .title-lecture {
        padding-left: 15px;
      }
    }
  }
</style>